import axios from 'axios';
import { TENANT_ENDPOINT } from '@dynameat/constants';
import { HttpController, SessionController } from '@/apps/core/helpers';
import apiClient from './store/apiclient';
import * as MutationTypes from './mutationTypes';

export const login = async ({ commit }, payload) => {
  try {
    commit(MutationTypes.AUTH_REQUEST);
    const { username: user, subdomain } = payload;
    const { data } = await apiClient.login(payload);
    const { token: rawToken } = data;
    const token = `JWT ${rawToken}`;
    SessionController.setupSession(token, subdomain, { user });
    HttpController.setupHttpClient(token);
    const { domain } = (await axios.get(TENANT_ENDPOINT())).data;
    if (domain !== subdomain) {
      throw Error('This tenant does not exist');
    }
    commit(MutationTypes.AUTH_SUCCESS, { token, user });
    return data;
  } catch (err) {
    SessionController.clearSession();
    HttpController.clearHttpClient();
    commit(MutationTypes.AUTH_ERROR);
    throw err;
  }
};

export const logout = async ({ commit }) => {
  commit(MutationTypes.LOGOUT);
  SessionController.clearSession();
  HttpController.clearHttpClient();
};
